<template>
  <div class="page-container">
    <Header />
    <div class="top">
      <div class="media-wrapper" style="display: flex; align-items: center; gap: 100px;">
        <div class="info">
          <span>{{ $t('radsys') }}</span>
          <span style="font-size: 14px;">{{ $t('radsys_full_desc') }}</span>
        </div>
        <img src="@/assets/images/03/RadSys/01.png" alt="">
      </div>
    </div>
    <div class="part-01" style="margin-top:-125px;">
      <div class="part-container media-container">
        <div class="part-left">
          <div class="item-row">
            <div class="item white">
              <span class="item-name">{{ $t('workstation') }}</span>
              <span class="item-sub-name">{{ $t('workstation_func') }}</span>
              <span class="item-desc">{{ $t('workstation_db') }}</span>
            </div>
          </div>
        </div>
        <div class="part-right">
          <div class="item-row">
            <div class="item gray">
              <span class="item-name">{{ $t('inspection_management') }}</span>
              <span class="item-sub-name">{{ $t('inspection_item') }}</span>
              <span class="item-desc">{{ $t('inspection_sync') }}</span>
            </div>
            <div class="item white">
              <span class="item-name">{{ $t('personal_management') }}</span>
              <span class="item-sub-name">{{ $t('personal_monitor') }}</span>
              <span class="item-desc">{{ $t('personal_analysis') }}</span>
            </div>
          </div>
          <div class="item-row">
            <div class="item red">
              <span class="item-name">{{ $t('environmental_management') }}</span>
              <span class="item-sub-name">{{ $t('env_detector') }}</span>
              <span class="item-desc">{{ $t('env_distribution') }}</span>
            </div>
            <div class="item gray">
              <span class="item-name">{{ $t('patient_management') }}</span>
              <span class="item-sub-name">{{ $t('patient_monitor') }}</span>
              <span class="item-desc">{{ $t('patient_sync') }}</span>
            </div>
            <div class="item white">
              <span class="item-name">{{ $t('wastewater_management') }}</span>
              <span class="item-sub-name">{{ $t('wastewater_measure') }}</span>
              <span class="item-desc">{{ $t('wastewater_control') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="part-02">
      <div class="part-container media-container">
        <div class="item-row">
          <div class="item">
            <div class="tag">{{ $t('comprehensive_management') }}</div>
            <img src="@/assets/images/03/RadSys/02.png" alt="">
            <span class="item-name">{{ $t('discharge_prediction') }}</span>
          </div>
          <div class="item">
            <img src="@/assets/images/03/RadSys/03.png" alt="">
            <span class="item-name">{{ $t('integrated_data') }}</span>
          </div>
          <div class="item">
            <img src="@/assets/images/03/RadSys/04.png" alt="">
            <span class="item-name">{{ $t('multi_platform') }}</span>
          </div>
          <div class="item">
            <img src="@/assets/images/03/RadSys/05.png" alt="">
            <span class="item-name">{{ $t('in_depth_analysis') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="part-03">
      <div class="part-container media-container">
        <img src="@/assets/images/03/RadSys/A.png" alt="" style="opacity: 0.6;">
        <div class="item-row">
          <div class="item red">
            <span class="item-name">ENGINEERING</span>
            <span class="item-name">A</span>
            <span class="item-name">SAFER WORLD</span>
          </div>
          <div class="item white">
            <span class="item-name">{{ $t('env_real_time') }}</span>
          </div>
          <div class="item gray">
            <span class="item-name">{{ $t('personal_dose') }}</span>
          </div>
          <div class="item white">
            <span class="item-name">{{ $t('big_data') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part-04" style="height: 100px;margin-top: 0;"></div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: '',
  components: {
    Header,
    Footer
  },
  data() {
    return {}
  },
  mounted() {
    
  }, 
  methods: {}
}
</script>

<style lang='less' scoped>
@import '@/assets/styles/views/common.less';

.page-container {
  background: linear-gradient(180deg, #89031c 0%, #89031c 650px,#fff 650px, #fff 100%);
  background-size: 100% 650px;
  background-repeat: no-repeat;
  width: 100%;
}

.top {
  /* width: 1200px;
  height: 500px; */
  margin: 0 auto;
  display: flex;
  gap: 20px;
  height: calc(100vh - 72px);
  background: #89031c;
  
  .info {
    display: flex;
    gap: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 40px;
    color: #fff;
    text-align: left;
    
    span {
      transition: transform 0.3s ease, color 0.3s ease;
      cursor: pointer;
      display: inline-block;
    }
    
    span:hover {
      transform: scale(1.02);
      color: white;
    }
  }
  
  img {
    width: 600px;
    height: auto;
    object-fit: contain;
    transition: transform 0.3s ease;
  }
  
  img:hover {
    transform: scale(1.05);
  }
}

.part-01 {
  margin-top: 0;
  
  .part-left {
    width: 50%;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
    
    .item {
      width: 500px;
      height: 500px;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      
      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
      }
    }
    
    &>img {
      right: 0;
      left: revert;
      width: 90%;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
    
    &>img:hover {
      transform: scale(1.05);
    }
  }
  
  .part-right {
    width: 50%;
    justify-content: flex-end;
    
    img {
      width: auto;
      height: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
    
    img:hover {
      transform: scale(1.05);
    }
  }
}

.part-02 {
  margin-top: 150px;
  height: 400px;
  background-color: rgb(77 77 77);
  
  .part-container {
    display: flex;
    flex-direction: column;
  }
  
  .item-row {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 60px;
    
    .item {
      flex: 1;
      position: relative;
      padding: 0;
      transition: transform 0.3s ease, opacity 0.3s ease;
      overflow: visible;
      
      &:hover {
        transform: translateY(-10px);
        opacity: 1;
      }
      
      .tag {
        position: absolute;
        top: -135px;
        left: 0;
        text-align: center;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }
      
      .tag:hover {
        transform: scale(1.1);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
      }
    }
    
    img {
      width: 100%;
      height: auto;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
    
    img:hover {
      transform: scale(1.1);
    }
    
    .item-name {
      font-size: 14px;
      color: #fff;
      transition: transform 0.3s ease;
    }
    
    .item-name:hover {
      transform: scale(1.05);
    }
  }
}

.part-03 {
  margin-top: 0;
  height: 500px;
  
  .part-container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    justify-content: center;
    
    &>img{
      width: 500px;
      height: 500px;
      position: absolute;
      top: 0;
      right: 0;
      transition: transform 0.3s ease;
    }
    
    &>img:hover {
      transform: scale(1.05);
    }
  }
  
  .item-row {
    display: flex;
    
    .item {
      width: 250px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 250px;
      position: relative;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      
      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
      }
      
      span {
        margin-bottom: 0;
        font-size: 14px;
        transition: transform 0.3s ease;
      }
      
      span:hover {
        transform: scale(1.05);
      }
    }
  }
}

/* 响应式适配使用公共样式 */

@media (max-width: 768px) {
  .page-container {
    background: linear-gradient(180deg, #89031c 0%, #89031c 250px, #fff 250px, #fff 100%);
    background-size: 100% 250px;
  }

  .top {
    height: auto;
    min-height: 300px;
    flex-direction: column;
    gap: 30px;
    padding: 20px 15px;

    .info {
      font-size: 24px;
    }

    img {
      width: 100%;
      height: auto;
      max-width: 300px;
    }
  }

  .part-01 {
    margin-top: 0;

    .part-left {
      width: 100%;

      .item {
        width: 100%;
        height: auto;
        min-height: 100px;
      }
    }

    .part-right {
      width: 100%;
    }

    .item-row {
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  .part-02 {
    margin-top: 50px;
    height: auto;

    .item-row {
      flex-wrap: wrap;
      gap: 10px;

      .item {
        flex: 1 1 100%;
        min-width: 0;
      }

      .tag {
        position: relative;
        top: auto;
        left: auto;
      }
    }
  }

  .part-03 {
    height: auto;

    .part-container {
      > img {
        position: relative;
        width: 100%;
        height: auto;
        max-height: 200px;
        top: auto;
        right: auto;
      }
    }

    .item-row {
      flex-wrap: wrap;
      gap: 10px;

      .item {
        width: 100%;
        height: auto;
        min-height: 80px;
      }
    }
  }

  .part-04 {
    height: auto;
  }
}
</style>